import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import militaryLoaderExpCalendar from '@/assets/landing-activity-male/military-loader-exp-calendar-2x.webp'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{
			config: {
				background: 'dark',
			},
			order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],
			components: {
				LandingHead: (): LandingComponentsConfig['LandingHead'] => ({
					logoAlignment: 'center',
					logoColor: 'white',
				}),

				LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
					img: militaryLoaderExpCalendar,
					customStyles: {
						marginBottom: 'var(--size-30)',
					},
				}),

				LandingTitle: ({ ctx, $t }): LandingComponentsConfig['LandingTitle'] => ({
					title:
						ctx.language === 'en'
							? 'Military Calisthenics Plan:<br/>See Results in 4 Weeks'
							: $t('military_calisthenics.pages.landing.loader.title_m'),
					size: 'medium',
					customStyles: {
						color: 'var(--Text-Primary-White, #ffffff)',
						textAlign: 'center',
						fontSize: 'var(--size-24)',
						marginBottom: 'var(--size-26)',
					},
				}),

				LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
					duration: 3500,
					theme: 'white',
				}),

				LandingFooter: (): LandingComponentsConfig['LandingFooter'] => ({
					textColor: 'white',
				}),
			},
		},
		{},
	]

	return mergeDeep([...schemas], extensionSchema)
}
